package com.wintermar.inspection.feature.domain.usecase.answer

import com.wintermar.inspection.core.domain.FlowBatchResult
import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.core.ui.component.image.util.FileChunkModel
import com.wintermar.inspection.feature.domain.repository.answer.AnswerChunkFileRepository
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.collectIndexed
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.flowOn
import kotlin.time.Duration.Companion.milliseconds

class UploadChunkFileUseCase(
    private val answerChunkFileRepository: AnswerChunkFileRepository
) {
    operator fun invoke(chunks: Flow<FileChunkModel>): Flow<FlowBatchResult<FileChunkModel>> =
        flow {
            var hasError = false
            var currentChunk: FileChunkModel? = null
            var processingCompleted = false

            chunks.collectIndexed { index, chunk ->
                if (hasError || processingCompleted) return@collectIndexed

                if (chunk.blob == null || chunk.blob.isEmpty()) {
                    hasError = true
                    emit(FlowBatchResult.Error(Exception("Chunk ${chunk.chunkNumber} cache missing.")))
                    return@collectIndexed
                }
                delay(100.milliseconds)
                answerChunkFileRepository.uploadChunkFile(chunk).collect { result ->
                    if (result is FlowResult.Success && index == 0) {
                        emit(FlowBatchResult.FirstProcess(result.data?.copy(blob = null)))
                    }

                    if (result is FlowResult.Success) {
                        deleteChunkFileAfterUpload(answerChunkFileRepository, result.data?.id ?: "")
                        currentChunk = result.data?.copy(blob = null)
                        emit(FlowBatchResult.Success(result.data))

                        if (chunk.chunkNumber >= (chunk.totalFiles - 1)) {
                            processingCompleted = true
                        }
                    } else if (result is FlowResult.Error) {
                        hasError = true
                        emit(FlowBatchResult.Error(result.error))
                    }
                }
            }

            if (!hasError) {
                emit(FlowBatchResult.Completed(currentChunk))
            }
        }.flowOn(Dispatchers.Default)
}

expect suspend fun deleteChunkFileAfterUpload(
    repository: AnswerChunkFileRepository,
    chunkId: String
)
